import script from "./WorkbenchRight.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkbenchRight.vue?vue&type=script&setup=true&lang=js"

import "./WorkbenchRight.vue?vue&type=style&index=0&id=0391e004&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0391e004"]])

export default __exports__